import React from 'react'
import RestaurantLanding from '../Components/Landing/RestaurantLanding';

const Home = () => {
  return (
    <div>
      {/* <ManagerLanding/> */}
      <RestaurantLanding/>
    </div>
  )
}

export default Home
